"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: 'fit-content'
    },
    avatar: {
      width: 60,
      height: 60
    },
    name: {
      color: theme.palette.primary.contrastText,
      marginTop: theme.spacing(1)
    }
  };
});

var SidebarProfile = function SidebarProfile(_ref) {
  var className = _ref.className,
      photoURL = _ref.photoURL,
      profileHref = _ref.profileHref,
      displayName = _ref.displayName,
      email = _ref.email,
      rest = _objectWithoutProperties(_ref, ["className", "photoURL", "profileHref", "displayName", "email"]);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: profileHref,
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    alt: "Person",
    className: classes.avatar,
    src: photoURL
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.name,
    variant: "h4"
  }, displayName), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    color: "textSecondary"
  }, email));
};

SidebarProfile.propTypes = {
  className: _propTypes.default.string,
  profileHref: _propTypes.default.string.isRequired
};
var _default = SidebarProfile;
exports.default = _default;